import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { MerchantService } from 'src/app/core/merchant.service';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';
import { TextsService } from 'src/app/core/texts.service';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.scss'],
})
export class LoginLayoutComponent implements OnInit {
  isMobile: boolean;
  tenant: string = '';
  merchant: string = '';
  isLoginPage: boolean;
  isLogin = false;
  isRegister = false;
  isPasswordReset: boolean;

  constructor(
    private readonly modalService: BoobleModalService,
    private readonly router: Router,
    private readonly merchantService: MerchantService,
    public tenantService: TenantGeneralService,
    private readonly route: ActivatedRoute,
    private readonly textsService: TextsService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    if (this.router.url.includes('pass')) {
      this.isPasswordReset = true;
    } else {
      this.isPasswordReset = false;
    }

    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
    this.merchant = this.merchantService.getLoginMerchant(this.tenant);
  }

  getWelcomeText(): string {
    return this.textsService.getText('welcome', this.tenant);
  }

  setIsLogin(event: boolean) {
    this.isLogin = event;
  }

  setIsPass(event: boolean) {
    this.isPasswordReset = event;
  }
}
